(function () {
  var config = (window.theme && window.theme.dropCollection) || {
    handle: 'drop',
    productHandles: []
  };

  var COLLECTION_URL = '/collections/' + config.handle;

  function isDropCollectionPath(pathname) {
    return new RegExp('/collections/' + config.handle + '/?$').test(pathname);
  }

  function isDropProductPath(pathname) {
    if (!config.productHandles || !config.productHandles.length) return false;

    return config.productHandles.some(function (handle) {
      return pathname.indexOf('/products/' + handle) !== -1;
    });
  }

  function isProtectedHref(href) {
    if (!href) return false;

    var path = href;

    try {
      path = new URL(href, window.location.origin).pathname;
    } catch (e) {}

    return isDropCollectionPath(path) || isDropProductPath(path);
  }

  function lockProtectedContent() {
    document.querySelectorAll('[data-drop-protected]').forEach(function (el) {
      el.classList.add('drop-section-locked');
    });
  }

  document.addEventListener('click', function (event) {
    if (isDropCollectionPath(window.location.pathname)) return;

    var link = event.target.closest('a[href]');
    if (!link) return;

    var href = link.getAttribute('href');
    var inProtectedSection = link.closest('[data-drop-protected]');

    if (isProtectedHref(href) || inProtectedSection) {
      event.preventDefault();
      event.stopPropagation();
      window.location.href = COLLECTION_URL;
    }
  }, true);

  if (!isDropCollectionPath(window.location.pathname)) {
    lockProtectedContent();
  }
})();
